// extracted by mini-css-extract-plugin
export default {"title":"BusinessProfile_title__EImyt","submit":"BusinessProfile_submit__hFxto"};